/**
 * 开发人员登录页
 */

import entry from "entry";
import NAPI from "nadaptor";
import { common as $common } from "utils";

import store from "./store";
import * as apis from "./apis";
import routes from "./routes";
import TrainContainer from "modules/TrainContainer";

import Vue from "vue";
import * as Sentry from "@sentry/vue";

Sentry.init({
    Vue,
    dsn: "https://82756b6dfdd9ff99e6ca661d081fcd9d@sentry.dev.aixuexi.com/31",
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    environment: window.__ENV__ ?? "development",
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });

const app = {
  components: {
    TrainContainer
  },

  data() {
    return {};
  },

  render(h) {
    // return <div id="foo">bar</div>
    return (
      <train-container>
        <div slot="main-container">
          <router-view></router-view>
        </div>
      </train-container>
    );
  }
};

const urls = {
  mobile: "/mobile/index.html",
  pc: "/index.html"
};

entry(
  app,
  {
    // setLocation () {
    //   if (!$common.isPc) {
    //     location.href = urls.mobile
    //     return false
    //   }
    // }
  },
  {
    apis,
    store,
    RouteConfig: {
      routes
    }
  }
);
